import { ID } from '@griply/types';

// No counts yet — assume open so a goal is never hidden while tasks resolve.
export const hasOpenTasks = (
  goalId: ID,
  taskCounts?: Map<ID, number>,
): boolean => {
  if (!taskCounts) {
    return true;
  }

  return !!(taskCounts.get(goalId) ?? 0);
};
